// cookies.setCookie('a','b', 5 * 1000)键，值，时间（5秒）
export const cookies = {
    setCookie: function (name, value, ms) {
      var expires = '';
      if (ms) {
        var date = new Date();
        date.setTime(date.getTime() + ms);
        expires = '; expires=' + date.toGMTString();
      }
      document.cookie = name + '=' + value + expires + '; path=/';
    },

    getCookie: function (name) {
      if (0 < document.cookie.length) {
        var k = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'));
        return null === k ? '' : k[2];
      }
      return null;
    },
  },
  // 0: sessionStorage 1: localStorage
  localCache = {
    ss: window.sessionStorage,
    ls: window.localStorage,

    getItem(key, type = 1) {
      var data = this[type ? 'ls' : 'ss'].getItem(key);
      try {
        return JSON.parse(data);
      } catch (err) {
        return data;
      }
    },
    setItem(key, val, type = 1) {
      this[type ? 'ls' : 'ss'].setItem(key, val);
      return this;
    },
    clear(type = 1) {
      this[type ? 'ls' : 'ss'].clear();
    },
    keys(type = 1) {
      return this[type ? 'ls' : 'ss'].keys();
    },
    removeItem(key, type = 1) {
      const data = this.getItem(key);
      this[type ? 'ls' : 'ss'].removeItem(key);
      return data;
    },
  };
